module.exports = __webpack_public_path__ + "5ec8f2c80b9076410d5ae8495eff7bab.pdf";